<template>
  <div class="page">
    <header-el></header-el>

    <section class="page-hero">
      <div class="ui-container">
        <p class="crumb">首页 / 产品与服务 / 大模型服务</p>
        <h1>大模型服务</h1>
        <p class="lede">
          集成多种 AI 算法，支持模型训练、部署和推理；从私有化部署到智能体工作流，
          让业务系统快速获得 AI 能力，深度赋能上层应用。
        </p>
      </div>
    </section>

    <div class="ui-container">
      <div class="float-panel">
        <div class="svc-grid">
          <div class="svc" v-for="s in llmServices" :key="s.name">
            <div class="svc__pic">
              <img :src="s.image" :alt="s.name" />
            </div>
            <div class="svc__body">
              <h3>{{ s.name }}</h3>
              <p class="svc__desc">{{ s.desc }}</p>
              <ul class="check-list">
                <li v-for="pt in s.points" :key="pt">{{ pt }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 私有化价值 -->
    <section class="section section--gray">
      <div class="ui-container">
        <div class="section-head">
          <span class="kicker">WHY US</span>
          <h2>为什么选择我们</h2>
          <p class="sub">AI 大模型中台 × 全流程交付，双重保障</p>
        </div>
        <div class="why">
          <div class="why__item card" v-for="w in whys" :key="w.name">
            <h3>{{ w.name }}</h3>
            <p>{{ w.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <footer-el></footer-el>
  </div>
</template>

<script>
  import Header from "../components/header.vue";
  import Footer from "../components/footer.vue";
  import { llmServices } from "../data/site.js";

  export default {
    components: {
      "header-el": Header,
      "footer-el": Footer
    },
    data() {
      return {
        llmServices,
        whys: [
          { name: "中台化底座", desc: "AI 大模型中台统一管理模型、知识库、提示词与智能体，上层应用即插即用。" },
          { name: "数据不出域", desc: "私有化部署 + 国产化算力兼容，敏感数据全程留在企业自有环境，满足合规要求。" },
          { name: "全流程交付", desc: "从场景盘点、语料准备到上线运维的闭环服务，显著降低落地成本与项目周期。" }
        ]
      };
    }
  };
</script>

<style scoped>
  .svc-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px 28px;
  }
  .svc {
    display: flex;
    gap: 18px;
    align-items: flex-start;
  }
  .svc__pic {
    flex: none;
    width: 110px;
    height: 110px;
    border-radius: 14px;
    overflow: hidden;
    background: #fdeceb;
    border: 1px solid #f6e0dd;
  }
  .svc__pic img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
  .svc__body { flex: 1; }
  .svc h3 { font-size: 17px; }
  .svc__desc {
    margin-top: 6px;
    font-size: 13px;
    color: #4c515b;
    line-height: 1.75;
  }
  .svc .check-list { margin-top: 8px; }
  .svc .check-list li { font-size: 13px; line-height: 1.8; }

  .why {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 22px;
  }
  .why__item { padding: 28px 26px; border-top: 3px solid #e8382f; }
  .why__item h3 { font-size: 17px; }
  .why__item p {
    margin-top: 8px;
    font-size: 13px;
    color: #4c515b;
    line-height: 1.8;
  }

  @media (max-width: 1023px) {
    .svc-grid { grid-template-columns: 1fr; }
    .why { grid-template-columns: repeat(2, 1fr); }
  }

  @media (max-width: 767px) {
    .svc { flex-direction: column; }
    .svc__pic { width: 100%; height: 160px; }
    .why { grid-template-columns: 1fr; }
  }
</style>
